import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { scrollToStep } from '../utils/scrollTo';

const ActiveNav = ({ step }) => {
  return (
    <>
      <ActiveStepDot />
      {step}
    </>
  );
};

const InactiveNav = ({ step }) => {
  return (
    <>
      <InactiveStepDot />
      <InactiveText>{step}</InactiveText>
    </>
  );
};

export const CampaignEditNavigation = ({ activeStep, steps }) => {
  return (
    <NavigationStepContainer>
      {steps.map(step => {
        return (
          <NavigationStep
            data-to-scrollspy-id={step.props.id}
            key={step.props.shortName}
            onClick={() => scrollToStep(step)}
          >
            {step.props.id === activeStep ? (
              <ActiveNav step={step.props.shortName} />
            ) : (
              <InactiveNav step={step.props.shortName} />
            )}
          </NavigationStep>
        );
      })}
    </NavigationStepContainer>
  );
};

const NavigationStepContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  gap: 10px;
  margin: 0 auto;
`;

const NavigationStep = styled.a`
  display: flex;
  align-items: center;
  padding: 5px;
  gap: 5px;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;

  &.active-scroll-spy {
    background-color: #e2ecf6;
    border-radius: 8px;
  }
`;

const ActiveStepDot = styled.div`
  background: ${themeGet('colors.primary.100')};
  border-radius: 50%;
  height: 5px;
  width: 5px;
  position: relative;
  box-shadow: 0 0 0 3px #b6d6f8;
  margin: 0px 5px;
`;

const InactiveStepDot = styled.div`
  background: ${themeGet('colors.grey')};
  border-radius: 50%;
  height: 5px;
  width: 5px;
  position: relative;
  margin: 0px 5px;
`;

const InactiveText = styled.span`
  color: ${themeGet('colors.grey')};
`;
